import { BookingFlowShell, type BookingFlowShellConfig } from '../../../booking-flow/BookingFlowShell';
import { ApprovalPassengerStep } from '../../../components/booking/ApprovalPassengerStep';
import {
  approvalEmployeeId,
  corporateMaxBudget,
  needsCorporateApproval,
} from '../../../components/booking/corporateApproval';
import { buildHotelGuestSlots, hotelFlowConfig, type HotelFlowState } from '../flowConfig';
import { hotelResumeAdapter } from '../resume';
import { SearchStep } from '../components/SearchStep';
import { ResultsStep } from '../components/ResultsStep';
import { GuestsStep } from '../components/GuestsStep';
import { ReservationStep } from '../components/ReservationStep';
import { PaymentStep } from '../components/PaymentStep';
import { DocumentStep } from '../components/DocumentStep';

function hotelApprovalActive(state: HotelFlowState, sessionEmployeeId: number | null) {
  const gate = { cart: state.shoppingCart, searchEmployeeId: state.searchRequest?.employeeID };
  const employeeId = approvalEmployeeId(gate, sessionEmployeeId);
  const singleGuest = buildHotelGuestSlots(state.searchRequest).length === 1;
  if (!singleGuest || !needsCorporateApproval(gate) || !employeeId) return null;
  return { employeeId, maxBudget: corporateMaxBudget(gate) };
}

const shellConfig: BookingFlowShellConfig<HotelFlowState> = {
  title: 'Otel Rezervasyonu',
  flowConfig: hotelFlowConfig,
  resumeAdapter: hotelResumeAdapter,
  sentForApproval: {
    isSent: (s) => !!s.sentForApproval,
    passengerStepId: 'guests',
    reservationPath: '/hotel/reservations',
    message:
      'Otel rezervasyonu onaya gönderilmiştir. Yöneticiniz onayladığında rezervasyon listenizden ödemeye devam edebilirsiniz.',
  },
  approvalGate: {
    passengerStepId: 'guests',
    isActive: hotelApprovalActive,
    render: ({ flow, running, employeeId, maxBudget }) => (
      <ApprovalPassengerStep
        employeeId={employeeId}
        maxBudget={maxBudget}
        productLabel="otel rezervasyonu"
        loading={running}
        onSubmit={(guests, contact, billingInformation) => {
          flow
            .runStep({ guests, contact, billingInformation, sentForApproval: true })
            .catch(() => undefined);
        }}
      />
    ),
  },
  renderStep: {
    search: () => <SearchStep />,
    allocate: () => <ResultsStep />,
    guests: () => <GuestsStep />,
    reservation: () => <ReservationStep />,
    payment: () => <PaymentStep />,
    document: () => <DocumentStep />,
  },
};

export default function HotelFlowPage() {
  return <BookingFlowShell config={shellConfig} />;
}
